import { combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BookingEngine, ConfigurationResult } from '@mews-distributor/data-access';
import { keyById } from '@mews/fp';
import { FETCH_CONFIGURATIONS_SUCCEEDED } from '../../configuration/actionTypes';

const dataInitialState: Record<string, BookingEngine> = {};

const bookingEnginesDataSlice = createSlice({
    name: 'bookingEngines',
    initialState: dataInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            FETCH_CONFIGURATIONS_SUCCEEDED,
            (
                state,
                {
                    payload: { bookingEngines },
                }: PayloadAction<ConfigurationResult, typeof FETCH_CONFIGURATIONS_SUCCEEDED>
            ) => ({ ...state, ...keyById(bookingEngines) })
        );
    },
});

export const bookingEnginesSlice = combineReducers({
    data: bookingEnginesDataSlice.reducer,
});
